import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../providers/root-store-provider';
import { BasePieChart } from './base/pie/base-pie-chart';
import { PieChartTypeEnum } from '../../../models/enums/pie-chart-type-enum';

type AssetDistributionChartType = {
    isFullScreen?: boolean;
    includeMinorCategories?: boolean;
};

export const AssetDistributionChart: React.FC<AssetDistributionChartType> = observer(
    ({ isFullScreen, includeMinorCategories }: AssetDistributionChartType) => {
        const { portfolioStore, statisticStore } = useRootStore();
        const { allocationTypeRatio, allocationTypeRatioFullScreen } = statisticStore.ratiosStore;

        React.useEffect(() => {
            if (includeMinorCategories && !allocationTypeRatioFullScreen) {
                statisticStore.ratiosStore.fetchRatios(true);
            }
        }, [includeMinorCategories]);

        const chartData = includeMinorCategories ? allocationTypeRatioFullScreen : allocationTypeRatio;

        if (!chartData) {
            return null;
        }
        return (
            <BasePieChart
                data={chartData.data}
                type={PieChartTypeEnum.AssetType}
                currency={portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode}
                isFullScreen={isFullScreen}
            />
        );
    },
);
